import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Chart } from 'chart.js/auto';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import html2canvas from 'html2canvas';
import { jsPDF as pdf } from 'jspdf';

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular


@Component({
    selector: 'app-avance-grafiaca',
    templateUrl: './avance-grafiaca.component.html',
    styleUrls: ['./avance-grafiaca.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      MatDatepickerModule,
      MatNativeDateModule,
      NgxMatSelectSearchModule
    ]
})
export class AvanceGrafiacaComponent implements OnInit {
  proyecto: Proyecto;

  constructor(
    public dialogRef: MatDialogRef<AvanceGrafiacaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data.proyecto && typeof this.data.proyecto === 'object') {
      this.proyecto = this.data.proyecto;
      this.renderizarGrafica();
    } else {
      console.error("proyecto no es un objeto válido::", this.data.proyecto);
    }
  }

  renderizarGrafica() {
    const ctxAvances = document.getElementById('graficaAvances') as HTMLCanvasElement;
    const horasIncurridas = this.proyecto.horasTotales - this.proyecto.horasEtc;
  
    const avanceGraf = new Chart(ctxAvances, {
      type: 'bar',
      data: {
        labels: [this.proyecto.nombre],
        datasets: [{
          label: 'Horas Autorizadas',
          // Barra base: las horas autorizadas contra sí mismas (100 %, o NaN y sin barra si no hay horas).
          data: [this.porcentaje(this.proyecto.horasTotales, this.proyecto.horasTotales)],
          backgroundColor: 'rgba(75, 192, 192, 0.5)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1
        }, {
          label: 'Horas Etc',
          data: [(this.proyecto.horasEtc / this.proyecto.horasTotales) * 100],
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1
        }, {
          label: 'Horas Incurridas',
          data: [(horasIncurridas / this.proyecto.horasTotales) * 100],
          backgroundColor: 'rgba(255, 255, 0, 0.5)', 
          borderColor: 'rgba(255, 255, 0, 1)',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
            max: 100
          }
        }
      }
    });
  
    const presupuestoCtx = document.getElementById('presupuestoGrafica') as HTMLCanvasElement;
    const presupuestoRes = this.proyecto.presupuestoAutorizado - this.proyecto.presupuestoGastado;
    const presupuestoGrafica = new Chart(presupuestoCtx, {
      type: 'bar',
      data: {
        labels: [this.proyecto.nombre],
        datasets: [{
          label: 'Presupuesto Autorizado',
          // Barra base: el presupuesto autorizado contra sí mismo (100 %, o NaN y sin barra si no hay presupuesto).
          data: [this.porcentaje(this.proyecto.presupuestoAutorizado, this.proyecto.presupuestoAutorizado)],
          backgroundColor: 'rgba(75, 192, 192, 0.5)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1
        }, {
          label: 'Presupuesto Gastado',
          data: [((this.proyecto.presupuestoGastado || 0) / this.proyecto.presupuestoAutorizado) * 100],
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1
        }, {
          label: 'Presupuesto Restante',
          data: [(presupuestoRes / this.proyecto.presupuestoAutorizado)* 100],
          backgroundColor: 'rgba(255, 255, 0, 0.5)', 
          borderColor: 'rgba(255, 255, 0, 1)',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
            max: 100
          }
        }
      }
    });
  }

  // Porcentaje de la parte sobre el total, la misma cuenta que el resto de las barras: con total 0
  // o nulo no da un número finito (NaN o Infinity) y Chart.js no dibuja esa barra.
  private porcentaje(parte: number, total: number): number {
    return (parte / total) * 100;
  }


  descargarPDF() {
    const seccionGraficas = document.getElementById('seccionGraficas');

    html2canvas(seccionGraficas as HTMLDivElement, { width: 600, height: 400 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

      const pdfDoc = new pdf();


      pdfDoc.addImage(imgData, 'PNG', 0, 0, pdfDoc.internal.pageSize.getWidth(), pdfDoc.internal.pageSize.getHeight());
      // pdfDoc.text( 'Horas autorizadas:', 100, 200);

      pdfDoc.save('graficasDeAvances.pdf');
    });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
}

